import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { postRequest } from '../../../Utils/AppApi';
import { ADMIN_FUND_PAYOUTMAKER } from '../../../Utils/appConstants';

function FundPayoutMakerRequest(props) {
  const [data, setData] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Handle file input change
  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (!file) {
      setErrorMessage('No file selected');
      return;
    }

    // Validate file type
    const validFileTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
    if (!validFileTypes.includes(file.type)) {
      setErrorMessage('Please upload a valid Excel file (.xlsx or .xls)');
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: 'binary' });

      // Get the first sheet from the Excel file
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Parse the sheet to JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      setData(jsonData);
      setErrorMessage(''); // Clear any previous error messages

      // Send the data to the backend
      saveDataToBackend(jsonData);
    };

    reader.readAsBinaryString(file);
  };

  const saveDataToBackend = (jsonData) => {
    postRequest(`${ADMIN_FUND_PAYOUTMAKER}`, { data: jsonData }).then((response) => {
      if (response.success === true) {
        console.log('Data sent successfully', response.data);
        setSuccessMessage('Data uploaded successfully!');


        setErrorMessage(''); // Clear any error message
      } else {
        alert('Error sending data');
      }
    }).catch(function (error) {
      console.log(error);
      setErrorMessage('An error occurred while uploading data.');
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', padding: '20px', backgroundColor: '#f9f9f9' }}>
  <div className="content-header my-0 py-0">
                    <div className="container-fluid">
                        <div className="row mb-0 align-items-left">
                            <div className="col-sm-6">
                                <h1 className='page-title text-blue font-merriweather'>Fund<span className='text-red'> Maker</span></h1>
                            </div>
                        </div>
                    </div>
                </div>
      
      
      <div style={{ textAlign: 'left', margin: '20px 0' }}>
        <input
          type="file"
          accept=".xlsx,.xls"
          onChange={handleFileUpload}
          style={{
            padding: '10px',
            fontSize: '16px',
            borderRadius: '5px',
            border: '1px solid #ccc',
            backgroundColor: '#fff',
            cursor: 'pointer'
          }}
        />
      </div>

      {errorMessage && <p style={{ color: 'red', textAlign: 'start' }}>{errorMessage}</p>}
      {successMessage && <p style={{ color: 'green', textAlign: 'start' }}>{successMessage}</p>}

      {data.length > 0 && (
        <div style={{ marginTop: '30px', flexGrow: 1 }}>
          <h2>Parsed Data:</h2>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px', border: '1px solid #ddd', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
            <thead>
              <tr>
                {Object.keys(data[0]).map((key, index) => (
                  <th key={index} style={{ padding: '12px', textAlign: 'left', backgroundColor: '#f1f1f1', fontWeight: 'bold' }}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  {Object.values(row).map((value, index) => (
                    <td key={index} style={{ padding: '12px', textAlign: 'left', border: '1px solid #ddd' }}>{value}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

    </div>
  );
}
export default FundPayoutMakerRequest;